<template>
    <div :class="{ wait: isLoginProcessing }">
        <router-link v-if="isLoggedIn && !iconBtn" :to="{ path: '/account' }" replace>
            <ion-item button lines="none" class="bold view-account">
                <ion-label> View Account </ion-label>
            </ion-item>
        </router-link>
        <ion-button v-else-if="isLoggedIn" fill="clear">
            <router-link :to="{ path: '/account', query: { utm_medium: 'web', utm_source: 'nav' } }" replace>
                <ion-icon :icon="require('@/assets/account-loggedin-icon.svg')" color="medium" class="mb-4" style="font-size: 30px" data-cy="desktop-account-icon" />
            </router-link>
        </ion-button>
        <ion-button v-else fill="clear" :disabled="isLoginProcessing">
            <router-link :to="'/login?redirect=/'">
                <ion-icon v-if="iconBtn" :icon="require('@/assets/account-icon.svg')" color="medium" style="font-size: 25px" data-cy="desktop-account-icon" />
            </router-link>
        </ion-button>
    </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { IonButton, IonItem, IonLabel, IonIcon } from '@ionic/vue';
import { useStore } from 'vuex';

export default defineComponent({
    props: { iconBtn: Boolean },
    components: {
        IonButton,
        IonItem,
        IonLabel,
        IonIcon,
    },
    setup() {
        const store = useStore();

        const isLoggedIn = computed(() => store.getters.isLoggedIn);
        const isLoginProcessing = computed(() => store.getters.isLoginProcessing);

        return {
            isLoggedIn,
            isLoginProcessing,
        };
    },
});
</script>

<style scoped>
.disabled {
    cursor: wait;
}

.view-account {
    --highlight-color-focused: white;
    --inner-border-width: 0;
    font-weight: bold;
    color: var(--ion-color-dark-shade);
    padding-left: 4%;
}
</style>
